import styled from 'styled-components'

export default styled.div`
  width: 180px;
  height: 180px;
  background-image: ${props => `url(${props.image})`};
  background-size: cover;
`